const Login = () => {
    return (
        <div className="flex gap-4">
            <div>Login</div>
        </div>
    )
}

export default Login;